import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import CurrentUserService from 'dashboard/services/current-user';
export default class DashboardIndexRoute extends Route {
  @service declare router: RouterService;
  @service declare currentUser: CurrentUserService;

  async redirect() {
    this.router.replaceWith(
      'dashboard.account',
      this.currentUser.selectedPurchaserId
    );
  }
}
